import SlideLayout from './SlideLayout';

export default function ProblemSection({ config }) {
  if (config?.problem_enabled === false) return null;

  const eyebrow = config?.problem_eyebrow || 'The situation';
  const title =
    config?.problem_title || 'Members wait. Staff repeats themselves. The data sits unused.';
  const points =
    Array.isArray(config?.problem_points) && config.problem_points.length > 0
      ? config.problem_points
      : [
          'Your staff answers the same member questions every week. That time adds up.',
          'Your member portal goes underused. The data your CRM holds stays invisible until renewal time.',
          'Requests fall through the cracks. Staff hours go to repetition, not the work that grows the association.',
        ];

  return (
    <SlideLayout eyebrow={eyebrow} title={title}>
      <div className="grid gap-6 sm:grid-cols-3 sm:gap-8">
        {points.map((point, index) => (
          <div key={point} className="flex flex-col gap-4 border-t border-tf-stone pt-5">
            <span className="font-brand text-[28px] font-light leading-none text-tf-teal sm:text-[32px]">
              {String(index + 1).padStart(2, '0')}
            </span>
            <p className="text-[16px] font-light leading-[1.55] text-tf-ink sm:text-[17px]">
              {point}
            </p>
          </div>
        ))}
      </div>
    </SlideLayout>
  );
}
